import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, inject } from '@angular/core';
import { ModalContainerComponent } from '@shared-lib/components/modal-container/modal-container.component';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { clearInterval, setInterval } from 'worker-timers';

export interface UserInactivityDialogComponentData {
  countdownSeconds: number;
}

@Component({
  selector: 'cp-user-inactivity-dialog',
  templateUrl: './user-inactivity-dialog.component.html',
  styleUrls: ['./user-inactivity-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ButtonModule, ModalContainerComponent],
})
export class UserInactivityDialogComponent implements AfterViewInit, OnDestroy {
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private readonly dynamicDialogRef = inject(DynamicDialogRef);
  private readonly dynamicDialogConfig: DynamicDialogConfig<UserInactivityDialogComponentData> = inject(DynamicDialogConfig);

  protected readonly dialogData = this.dynamicDialogConfig.data;
  protected isDialogPositionUp = false;
  private countdownTimer: number;
  protected remainingSeconds = this.dialogData.countdownSeconds || 120;

  ngAfterViewInit(): void {
    requestAnimationFrame(() => {
      this.isDialogPositionUp = true;
      this.changeDetectorRef.markForCheck();
    });

    this.startTimeout();
  }

  startTimeout(): void {
    this.countdownTimer = setInterval(() => {
      this.remainingSeconds--;
      this.changeDetectorRef.markForCheck();
      if (this.remainingSeconds <= 0) {
        this.clearCountdown();
        this.logout();
      }
    }, 1000);
  }

  logout(): void {
    this.dynamicDialogRef.close(true);
  }

  stayLogged(): void {
    this.dynamicDialogRef.close(false);
  }

  clearCountdown(): void {
    clearInterval(this.countdownTimer);
  }

  ngOnDestroy(): void {
    this.clearCountdown();
  }
}
